import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import CouponEvent from './CouponEvent';
import SystemTuples from './SystemTuples';

export default function SystemBets(props) {
    const betslipContext = useContext(BetslipContext);
	
	let betslipData = betslipContext.getBetslipData();
	const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const container = 'systembets';
    const reactKeyTuples = `key-tuples-container${couponKey}-container-${container}`;
    let selections = coupon.selections;

    return (
        <>
            {selections.map(selection => {
                let reactKey = `key-bet-event-coupon-${couponKey}-container-${container}-pal-${selection.pal}-avv-${selection.avv}`;
                return (
                    <React.Fragment key={reactKey}>
                        <CouponEvent selection={selection} couponKey={couponKey} container={container} />
                    </React.Fragment>
                )
            })}
            <SystemTuples container={container} couponKey={couponKey} key={reactKeyTuples} />
        </>
    );
}
